import * as constants from './constants'

export const addCreditCard = (temporaryToken, nameOnCard) => ({
    type: constants.ADD_CREDIT_CARD,
    temporaryToken,
    nameOnCard,
})

export const addCreditCardStateReset = () => ({
    type: constants.ADD_CREDIT_CARD_RESET,
})

export const addCreditCardFailure = () => ({
    type: constants.ADD_CREDIT_CARD_FAILURE,
})
